import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.reset-password', {
        url: '/reset-password/:appKey?SAMLTracker&icon',
        params: {
        	appName:null,
        	appType:null,
        
          },
        resolve:{appData},
        component:'resetPassword'
    });
}


/** @ngInject */
function appData($stateParams,SamlService) {
    return SamlService.getAppAccountFormat.get({appKey : $stateParams.appKey}).$promise;
}


// WEBPACK FOOTER //
// ./src/portal/states/public/reset-password/reset-password.state.js